import { Socket, io } from 'socket.io-client';

import { getAuthClient, getUser, getToken } from '@verantos-dev/core-auth';

let socket: Socket | undefined;

export const initSocket = async (path: string, namespace?: string): Promise<undefined> => {
  const token = await getToken();
  const client = await getAuthClient();
  const auth0User = await client.getUser();
  const url = new URL(import.meta.env.VITE_BASE_SOCKET_URL);
  url.pathname = namespace ?? url.pathname;

  if (auth0User && !socket) {
    const user = getUser(auth0User);
    socket = io(url.toString(), {
      path,
      auth: {
        token,
      },
      transports: ['websocket'],
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      randomizationFactor: 0.8,
      query: {
        userId: user.auth0Id,
        user: `${user.firstName} ${user.lastName}`,
        token,
      },
    });
  }
};

export const getSocketV2ResearchAssistant = async (namespace?: string) => {
  await initSocket('/v2/research-assistant', namespace);
  return socket;
};

export const cleanupSocketV2ResearchAssistant = () => {
  if (socket) {
    socket.disconnect();
    socket = undefined;
  }
};

export const emitSocketV2ResearchAssistantEvent = (event: string, data: any) => {
  if (socket) {
    socket.emit(event, data);
  }
};
